import { Observable } from "rxjs";
import { ApiResponse } from "./types.domain";

export type GetCronJobsFn = (limit: number, offset: number, filter: string | null, category: string | null) => Observable<CronJobPaginablePayloadApiResponse<CronJob> | null>;
export type GetCronJobsGroupedFn = (filter: string | null) => Observable<CronJobGroupedPayloadApiResponse | null>;
export type GetCronJobInstancesFn = (limit: number, offset: number, filter: string | null, cronJobId: number | null, status: string | null) => Observable<CronJobInstancePaginablePayloadApiResponse<CronJobInstanceWithCronJob> | null>;
export type RunCronJobFn = (route: string) => Observable<any>;


export interface CronJobInstancePaginablePayloadApiResponse<P> extends ApiResponse {
    limit: number;
    offset: number;
    total: number;
    payload: P[];
    cronJobs: CronJob[];
  }
  
  export interface CronJobPaginablePayloadApiResponse<P> extends ApiResponse {
    limit: number;
    offset: number;
    total: number;
    payload: P[];
    categories: string[];
  }

export interface CronJobGroupedPayloadApiResponse {
    status: boolean;
    message: string;
    total: number;
    payload: { [category: string]: CronJob[] };
    categories: string[];
    grouped: boolean;
}
export interface CronJob {
    id: number;
    name: string;
    description?: string;
    createdTime: Date;
    route: string;
    lastSuccessInstanceId_D?: number;
    lastFailureInstanceId_D?: number;
    category?: string;
}
export interface CronJobToSave {
    name: string;
    description: string;
    route: string;
    category?: string;
}

export interface CronJobInstance {
    id: number;
    cronJobId: number;
    status: 'started' | 'success' | 'failed';
    createdTime: Date;
    completedTime?: Date;
    errorMessage?: string;
} 

export interface CronJobInstanceWithCronJob extends CronJobInstance {
    id: number;
    cronJobId: number;
    status: 'started' | 'success' | 'failed';
    createdTime: Date;
    completedTime?: Date;
    errorMessage?: string;
    cronJobName: string;
    cronJobDescription: string;
    cronJobRoute: string;
    cronJobCategory: string;
} 
